import React from 'react';
import { Link } from 'react-router-dom';

import { useTranslation } from 'providers/GILT.provider';

import HeaderContainer from 'user/common/Header';

let fbSalonId;
if (window.location.href.indexOf('state=') > 0) {
  [, fbSalonId] = window.location.href.split('state=');
  window.faceBookSalonId = fbSalonId;
}

const NotFoundComponent = (props) => {
  const { t } = useTranslation();

  if (props.location.pathname.indexOf('state=') >= 0) {
    const salonId = props.location.pathname.split('state=')[1];
    props.history.push(`/salon/${salonId}/onlinebooking`);
    return null;
  }

  return (
    <div className="screen-wrap">
      <div className="header-bg" />
      <div className="content-wrap">
        <HeaderContainer title={t('composite.notFoundPage.title')} description={t('composite.notFoundPage.subtitle')} />
        <div className="content login auto-height">
          <div>{t('composite.notFoundPage.description.part1')}</div>
          <br />
          <div>{props.location.pathname}</div>
          <br />
          <div>{t('composite.notFoundPage.description.part2')}</div>
          <br />
          <Link to="/login" href="/login" className="btn btn-violet-link">
            {t('composite.notFoundPage.loginButton')}
          </Link>
          <a className="btn btn-violet-link" href="https://getslick.com/" target="_blank" rel="noopener noreferrer">
            {t('composite.notFoundPage.slickWebsiteButton')}
          </a>
          <Link to="/signup" href="/signup" className="btn btn-violet-link">
            {t('composite.notFoundPage.signUpButton')}
          </Link>
        </div>
      </div>
      <footer className="footer" />
      <div className="footer-additional" />
    </div>
  );
};

export default NotFoundComponent;
